import React, { useState, useCallback } from 'react';
import { func } from 'prop-types';
import { translate } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

import Accordion from '@dragonfruit/components/Accordion';

import { FAQ_BLOCK } from '@dragonfruit/constants/premiumPage';

import styles from './PremiumFAQ.scss';

function PremiumFAQ({ t }) {
  const [selectedFaq, setSelectedFaq] = useState('');
  const questions = t('premium.faq.questions', {
    returnObjects: true,
    defaultValue: [],
  });

  const finalQuestions = questions.filter(({ a }) => a && a !== '-');

  const handleSelectFaq = useCallback(value => {
    setSelectedFaq(pre => (pre === value ? '' : value));
  }, []);

  const renderAccordianTab = (question, index) => (
    <Accordion.Tab
      key={index}
      label={question.q}
      value={question.link}
      onClick={handleSelectFaq}
      selected={selectedFaq === question.link}
    >
      <ReactMarkdown source={question.a} />
    </Accordion.Tab>
  );

  return (
    <section className={styles.root} id={FAQ_BLOCK}>
      <h3 className={styles.title}>{t('premium.faq.title')}</h3>
      <Accordion>{finalQuestions.map(renderAccordianTab)}</Accordion>
    </section>
  );
}

PremiumFAQ.propTypes = {
  t: func.isRequired,
};

export default translate(['premium'])(PremiumFAQ);



// WEBPACK FOOTER //
// ./app/containers/Premium/components/PremiumFAQ/PremiumFAQ.jsx